



























import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import ReimbursementHistoryRow from "./ReimbursementHistoryRow.vue";
import Widget from "@/shared/components/Widget.vue";
import { FetchState, Reimbursement } from "@/shared/types";
import Pagination from "@/shared/components/ui/Pagination.vue";
import {
Vue,
Component,
} from "@/shared/vuepack";
import { useReimburseMeStore } from "@/employee/store/reimburseMe";

@Component({
components: {
    Widget,
    GenericLoadingSpinner,
    ReimbursementHistoryRow,
    Pagination
 }
})
export default class ReimbursementHistoryTable extends Vue {
  reimbursementStore = useReimburseMeStore();


mounted () {
  this.reimbursementStore.load();
}

getReimbursedList (): Reimbursement[] {
  return this.reimbursementStore.getList(this.page);
}

get page (): number {
  return this.reimbursementStore.currentPage;
}

get anyPages (): boolean {
  return this.reimbursementStore.hasPages;
}

get numberOfPages (): number {
  return this.reimbursementStore.pageCount;
}

get rangeOfPages (): number[] {
  return this.reimbursementStore.pageRange;
}

get isLoaded (): boolean {
  return this.reimbursementStore.getFetchState === FetchState.Loaded;
}

get numberOfReimbursements () {
  return this.reimbursementStore.totalNumberOfReimbursements;
}

onSwitchPage (pageNumber): void {
  this.reimbursementStore.loadPage({
    page: pageNumber,
    force: false
  });
}
}
